module.exports = __webpack_public_path__ + "static/img/arrow.a65d5cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow.png
// module id = qNF3
// module chunks = 1